import axios from 'axios';
import qs from 'qs';
import NProgress from 'nprogress';

export const apiInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  withCredentials: true
});


export const apiCloudInstance = axios.create({
  baseURL: process.env.VUE_APP_API_CLOUD_URL,
  timeout: 10000,
  withCredentials: true
});

// 登录
export const login = params => {
  return apiCloudInstance.post(`api-study/v1/users/login`, params);
};

export const teachManageLogin = params => {
    return apiInstance.post(`api/study/user/login`, params);
};

// 资讯列表
export const listNews = params => {
    return apiInstance.get(`api/cms/news/list`, {params: params});
};

// 轮播图列表
export const getRecommendList = params => {
    return apiInstance.get(`api/cms/carouselFigure/getRecommendList`, {params: params});
};

// 资讯详情
export const getNews = params => {
    return apiInstance.get(`api/cms/news/getNews`, {params: params});
};

// 获取服务器当前时间
export const getServerNowTime = () => {
    return apiInstance.get(`api/study/student/getServerNowTime`);
};

// 获得学员的字典信息
export const getUserDictByColumType = params => {
    return apiInstance.get(`api/study/student/getUserDictByColumType`, {params: params});
};

// 根据单位名称模糊匹配获取单位信息，以及省市县乡
export const listByCompName = params => {
    return apiInstance.get(`api/study/comp/listByCompName`, {params: params});
};

// 获得省市县乡
export const getCustomAreaList = params => {
    return apiInstance.get(`api/study/public/getCustomAreaList`, {params: params});
};

// 获得单位下的科室
export const getdepartmentByOrgId = params => {
    return apiInstance.get(`api/study/student/getdepartmentByOrgId`, {params: params});
};

// 获得专业1
export const getSpecialty1Indexs = params => {
    return apiInstance.get(`api/study/student/getSpecialty1Indexs`, {params: params});
};

// 获得专业2
export const getSpecialty2Indexs = params => {
    return apiInstance.get(`api/study/student/getSpecialty2Indexs`, {params: params});
};

// 图形验证码验证
export const valilCaptcha = params => {
    return apiInstance.get(`api/public/captcha/valilCaptcha`, {params: params});
};

// 发送手机验证码
export const sendSms = params => {
    return apiInstance.get(`api/public/sms/sendSMS`, {params: params});
};

// 验证手机验证码
export const validateMobileCode = params => {
    return apiInstance.get(`api/public/sms/validateMobileCode`, {params: params});
};

// 验证手机号唯一性
export const vftelStudent = params => {
    return apiInstance.get(`api/study/student/vftelStudent`, {params: params});
};

// 验证用户名唯一性
export const checkUsername = params => {
    return apiInstance.get(`api/study/student/checkUsername`, {params: params});
};

// 学员注册
export const studyRegister = params => {
    return apiInstance.post(`api/study/student/register`, params);
};

// 验证验证证件号唯一性
export const verificationStudent = params => {
    return apiInstance.get(`api/study/student/verificationStudent`, {params: params});
};

// 忘记密码
export const updatePwd = params => {
    return apiInstance.post(`api/study/student/updatePwd`, params);
};


// 获取培训班列表
export const trainings = params => {
    return apiCloudInstance.get(`api-study/v1/trainings`, {params: params});
};

// 忘记密码
export const addUser2Training = (traingingId,userId) => {
    return apiCloudInstance.post(`api-study/v1/trainings/`+traingingId+`/users/`+userId );
};

// 获取培训班列表
export const trainingOfUser = (userId,params) => {
    return apiCloudInstance.get(`api-study/v1/users/`+userId+`/trainings`, {params: params});
};

// 加载拦截
apiInstance.interceptors.request.use(function (config) {
  NProgress.start();

  //注意跟后台交互时array会被自动转换，
  //https://www.npmjs.com/package/query-string
  if (config.method === 'post') {
    config.data = qs.stringify(config.data);
  }
  return config;
}, function (error) {
  NProgress.done();
  return Promise.reject(error);
});

apiInstance.interceptors.response.use(function (response) {
  NProgress.done();
  return response;
}, function (error) {
  if(!(error.config.url.indexOf("api/study/student/authJWT")!=-1)){
    alert('网络异常！')
  }
  NProgress.done();
  return Promise.reject(error);
});

apiCloudInstance.interceptors.request.use(function (config) {
  NProgress.start();

  //注意跟后台交互时array会被自动转换，
  //https://www.npmjs.com/package/query-string
  if (config.method === 'post' && config.url.indexOf("api-exam")<0) {
    config.data = qs.stringify(config.data);
  }
  return config;
}, function (error) {
  NProgress.done();
  return Promise.reject(error);
});

apiCloudInstance.interceptors.response.use(function (response) {
  NProgress.done();
  if(response.data.code == 1){
    alert(response.data.msg)
    return Promise.reject(response.data);
  }
  return response;
}, function (error) {
  if(!(error.config.url.indexOf("gw/v1/authorizations/jwt")!=-1)){
    alert("网络异常！")
  }
  NProgress.done();
  return Promise.reject(error);
});
